import { Dialog } from '@angular/cdk/dialog'
import { DatePipe } from '@angular/common'
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewContainerRef
} from '@angular/core'
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { OrderEntry } from '@spartacus/cart/base/root'
import { GlobalMessageType, RoutingService, User } from '@spartacus/core'
import { Order } from '@spartacus/order/root'
import { LaunchDialogService } from '@spartacus/storefront'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { AddressBookComponentService } from '@spartacus/user/profile/components'
import { Observable, of, Subject } from 'rxjs'
import { debounceTime, finalize, map, mergeMap, tap } from 'rxjs/operators'
import {
  ClaimReason,
  CreditClaim,
  CreditClaimItem,
  CreditClaimMediaUpload
} from '../../../../models/credit-claims.model'
import { CustomRoutes } from '../../../../models/enum/custom-routes.enum'
import { SharedValue } from '../../../../models/enum/shared.enum'
import { ICustomAddress } from '../../../../models/interface/address.interface'
import { ICustomMedia } from '../../../../models/interface/media.interface'
import { ICustomOrderEntry } from '../../../../models/interface/order-entry.interface'
import { CMSCommentWsDTOCMSCommentWsDTO } from '../../../../models/shared.model'
import { CreditClaimsService } from '../../../../services/creditClaims/credit-claims.service'
import { CustomSearchBoxComponentService } from '../../../../services/custom-search-box-component.service'
import { OrderHistoryService } from '../../../../services/order-history.service'
import { CustomGlobalMessageService } from '../../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../../services/shared/shared.service'
import { NewCreditClaimPhotoUploadModalComponent } from '../new-credit-claim-photo-upload-modal/new-credit-claim-photo-upload-modal.component'
import { RestockFeesNoModalComponent } from '../restock-fees-no-modal/restock-fees-no-modal.component'
import { SecondClaimModalComponent } from '../second-claim-modal/second-claim-modal.component'
import { ShortOversuppliedModalCollectedComponent } from '../short-oversupplied-modal-collected/short-oversupplied-modal-collected.component'
import { ShortOversuppliedModalComponent } from '../short-oversupplied-modal/short-oversupplied-modal.component'
import { Company } from './company'

@Component({
    selector: 'app-newcredit-claims-with-order',
    templateUrl: './newcredit-claims-with-order.component.html',
    styleUrls: ['./newcredit-claims-with-order.component.scss'],
    standalone: false
})
export class NewcreditClaimsWithOrderComponent implements OnInit {
  public claimReasonForm: FormGroup
  public claimForm!: FormGroup
  public addItemForm: FormGroup
  public pickupForm: FormGroup
  public stockForm!: FormGroup

  public otherReasonForm: FormGroup
  public formSubmitted = false
  public claimReasons: ClaimReason[] = []
  public orderCode: string
  public user$: Observable<User>
  public reasonView = true
  public invoiceView = false
  public confirmationView = false
  public order: Order
  public creditClaim: CreditClaim = new CreditClaim()
  public creditClaimAddItems: CreditClaimItem[]
  // public modalRef: ModalRef;
  public modalRef: any

  public spinner = false
  public photoMandatoryReasons = ['DAMAGED_STOCK', 'REQUEST_RETURN', 'FAULTY_STOCK', 'OTHER']
  //public photoMandatoryReasons = ['RECEIVED_DAMAGED', 'DAMAGED_STOCK', 'REQUEST_RETURN', 'EXPIRED_STOCK', 'FAULTY_STOCK']
  public commentMandatoryReasons = [
    'OVER_SUPPLIED',
    'SHORT_SUPPLIED',
    'SHORT_OVER_SUPPLIED',
    'DAMAGED_STOCK',
    'REQUEST_RETURN',
    'FAULTY_STOCK'
  ]
  public claimGstValue: boolean = false
  public claimValue: any
  public isReview: boolean = false
  public isInstead: boolean = true
  public isStock: boolean = false
  public isPurchaseOrderNumber: boolean = false
  public pickUpAddressDetails: boolean = false
  public isPickUpDetails: boolean = false
  public ispickUp: boolean = false
  public isUpdatedCollection: boolean = false
  //private  = false;
  isOverSuppliedPdt: Subject<boolean> = new Subject()
  public textVal = 1
  public customLable: boolean = false
  public selectedLable: boolean = true
  public customLabel = 'Short and over supplied - Over supplied'
  public shortAndOverSupplied = 'Short and Over Supplied'
  public shortOversupplied = 'SHORT_OVER_SUPPLIED'
  public userDeta: any
  submittedReason: any
  submittedTicket: any
  ticketId: any
  confirmView: boolean = true
  notThreemonthOld: boolean = false
  selectedYesstock: any
  selectedNostock: any

  public ShortOverSuppliedRelatedTicketId = false
  public onlyTicketId = false
  public onlyRelatedTicketId = false
  submittedRelatedTicketId: boolean = false
  isDisabled: boolean = false
  tex: any
  GstValue: any
  numberData: any
  accumulator: number
  currentValue: number
  addressdata: any
  shortAndOverSuppliedMsg: boolean = false
  overSuppliedInstead: boolean = false
  damagedStockAddCommentBtn: boolean = false
  damagedStockAddCommentMsg: boolean = false
  faultyStockMsg: boolean = false
  reqReturnStockBtn: boolean = false
  dateOlderThreeMonths: boolean = false
  dateWithinThreeMonths: boolean = false
  deliveryDate: string
  reStockFees: boolean = false
  requestReturnStockReason: boolean = false
  returnStockReviewed: boolean = false
  reqReturnStockPanel: boolean = false
  otherDefaultReview: boolean = false
  otherReasonReviewed: boolean = false
  otherReasonIsStockReview: boolean = false
  otherClaimReason: boolean = false
  shortAndOverSuppliedReason: boolean = false
  defaultHeaderWithReason: boolean = false
  requestReturnFlag = ''
  addComment: boolean = false
  addPhotoOrComment: boolean = false
  isSuppliedPdt: boolean
  creditClaimItems: CreditClaimItem[] = []
  public loggedin = sessionStorage.getItem('userDetails')
  userlog: any
  materialQtyFlag: boolean = false
  data = []
  dataNew = []
  productUom: any
  searchUom = []
  firstValues = ''
  secondValues = ''
  val: any
  newArrays = []
  reasonChange: string
  reasonChangeforShort: string
  reasonShortOnetime: boolean = false
  reasonFlag: boolean = false
  addItembtn: boolean = false
  checkbox: boolean = false
  @ViewChildren('TextInput') public textInputs: QueryList<ElementRef>
  @ViewChild('myTable') myTable: ElementRef
  @ViewChild('auto') autocompletefield: ElementRef
  columnValues: string[]
  changeclaims: any
  stockCollected: boolean
  changeclaims2: any
  isStockObservable: Subject<boolean> = new Subject()
  isPickupObservable: Subject<boolean> = new Subject()
  addresses$: Observable<ICustomAddress[]>
  touchedRows: any
  materialData: FormArray
  newOrderEnteries: ICustomOrderEntry[] = []

  selectedOpt: string

  listOfItems: FormArray

  materialCodetest = new FormControl('')

  addMatItem = new FormControl('')

  // @Input() companyForm: FormGroup;
  filteredCompanies: Observable<Company[]>

  @Output() optionSelected = new EventEmitter()
  apidata: Observable<Company[]>

  itemNameList = []

  materialCode: FormControl
  @ViewChild('openElement') openElement: ElementRef
  dialogRef: any
  message: any
  addPopupComments: any
  addPopupImage: any
  addPopupImageLength: any
  shortSuppliedInsteadForm: boolean = false

  constructor(
    private fb: FormBuilder,
    private creditClaimsService: CreditClaimsService,
    private changeDetectorRef: ChangeDetectorRef,
    public globalMessageService: CustomGlobalMessageService,
    public sharedService: SharedService,
    // private userService: UserService,
    private userService: UserAccountFacade,
    private orderHistoryService: OrderHistoryService,
    private launchDialogService: LaunchDialogService,
    public routingService: RoutingService,
    public dialog: Dialog,
    public cd: ChangeDetectorRef,
    private customSearchBoxComponentService: CustomSearchBoxComponentService,
    public datepipe: DatePipe,
    public addressService: AddressBookComponentService,
    public vcr: ViewContainerRef
  ) {
    this.isOverSuppliedPdt.subscribe((value) => {
      this.isSuppliedPdt = value
    })
  }

  // public getAllMaterials() {
  //   let totPages =0;
  //   let result = null;
  //   let count = 0;
  //   for (let k = 0; k < 10; k++) {
  //     result = this.customSearchBoxComponentService.getMaterialSearch("",k);
  //     count++;
  //     if(result.pagination){
  //       break;
  //     }
  //   }
  //   if(result){
  //   result.subscribe(res=>{
  //   totPages = res.pagination.totalPages
  //   if(totPages > 0){
  //          for (let i = count-1; i < totPages; i++) {
  //            this.customSearchBoxComponentService.getMaterialSearch("",i)
  //            .subscribe(res=>{
  //              this.data = this.data.concat(res.products);
  //             // console.log(" ppp3 ",this.data)
  //            },  error => {
  //            console.log(error);
  //           },
  //           )

  //          }

  //        }

  //      })

  //     }

  //  }

  ngOnInit(): void {
    this.initiateFormControls()
    this.getClaimReasons()
    this.sharedService.getUrlParam('code').subscribe((orderCode) => {
      if (orderCode) {
        this.orderCode = orderCode
        this.getOrder(orderCode)
      }
    })
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    this.user$ = this.userService.get()

    this.userlog = JSON.parse(this.loggedin)

    const getAddress = sessionStorage.getItem('address')
    this.addressdata = getAddress
    this.addressdata = JSON.parse(getAddress)

    // this.addresses$ = this.addressService.getAddresses();
    // vimal 20.11
    // this.addressService.loadAddresses();

    //this.getAllMaterials();

    let totPages = 0
    let result = null
    let count = 0
    for (let k = 0; k < 1; k++) {
      result = this.customSearchBoxComponentService.getMaterialSearch('', k)
      count++
      if (result.pagination) {
        break
      }
    }
    if (result) {
      result.subscribe((res) => {
        totPages = res.pagination.totalPages
        if (totPages > 0) {
          for (let i = count - 1; i < totPages; i++) {
            this.customSearchBoxComponentService.getMaterialSearch('', i).subscribe(
              (res) => {
                this.data = this.data.concat(res.products)
                this.apidata = of(this.data)
              },
              (error) => {
                console.log(error)
              }
            )
          }
        }
      })
    }
    //starting code
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    this.filteredCompanies = this.claimForm
      .get('matData')
      .valueChanges.pipe(
        tap((val) => console.log('inside valueChanges : ', val)),
        debounceTime(200)
      )
      .pipe(mergeMap((val) => this.filter(val)))
    // end
  }

  displayFn(materialCode) {
    return materialCode.code
  }

  get matData(): FormArray {
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    return this.claimForm.get('matData') as FormArray
  }

  private filter(value: any | Company): Observable<Company[]> {
    value.forEach((element) => {
      this.val = element.materialCode
      this.searchUom.push(element.materialCode)
    })
    if (this.val) {
      return this.apidata.pipe(
        map((cos: Company[]) => {
          return cos.filter((co: Company) => {
            // return (co.code.toLowerCase().search((typeof this.val === 'string') ? this.val.toLowerCase() : (<Company> this.val).name.toLowerCase()) !== -1)
            return co.code.toLowerCase().startsWith(this.val)
          })
        })
      )
    } else {
      return this.apidata
    }
  }

  onSelectionChanged(event: any, i) {
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    const d = this.claimForm.get('matData') as FormArray
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    d.controls[i].get('itemDesc').setValue(event.name)
    if (event === '') {
      this.addItembtn = false
    } else {
      this.addItembtn = true
    }
  }

  addItem() {
    this.matData.push(
      new FormGroup({
        materialCode: new FormControl(''),
        itemDesc: new FormControl(''),
        materialQuantity: new FormControl(''),
        total: new FormControl('')
      })
    )
  }

  public getClaimReasons(): void {
    this.creditClaimsService.getCreditClaimReasons().subscribe(
      (reasons: ClaimReason[]) => {
        if (reasons) {
          const reasonOrder = []
          reasonOrder.push(reasons[9])
          reasonOrder.push(reasons[5])
          reasonOrder.push(reasons[8])
          reasonOrder.push(reasons[3])
          reasonOrder.push(reasons[1])
          reasonOrder.push(reasons[4])
          reasonOrder.push(reasons[7])
          this.claimReasons = reasonOrder
          // this.claimReasons = reasons;

          this.changeDetectorRef.detectChanges()
        } else {
          this.changeDetectorRef.detectChanges()
          this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
        }
      },
      (err) => {
        this.globalMessageService.add(SharedValue.incorrectorderNumber, GlobalMessageType.MSG_TYPE_ERROR)
        // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
        this.routingService.go({ cxRoute: CustomRoutes.CREDIT_CLAIMS })
      }
    )
  }

  public initiateFormControls(): void {
    this.claimReasonForm = this.fb.group({
      claimReasonControl: ['', [Validators.required]]
    })

    this.claimForm = new FormGroup({
      matData: new FormArray([
        new FormGroup({
          materialCode: new FormControl(''),
          itemDesc: new FormControl(''),
          materialQuantity: new FormControl(''),
          total: new FormControl('')
        })
      ])
    })

    this.stockForm = new FormGroup({
      // stockaccept: new FormControl('')
    })

    this.otherReasonForm = new FormGroup({
      // otherReasonReviewCheck: new FormControl(''),
      // otherreasonyes: new FormControl(''),
      // otherreasonno: new FormControl('')
    })
    this.pickupForm = new FormGroup({})
  }

  public onReasonSelected(e, reason: string): void {
    // this.invoiceView = true;
    // this.isStockObservable.next(false);
    if (reason == 'SHORT_SUPPLIED') {
      this.defaultHeaderWithReason = true
      this.reasonView = false
      this.invoiceView = true
      this.damagedStockAddCommentBtn = false
      this.shortAndOverSuppliedMsg = false
      this.dateWithinThreeMonths = false
      this.dateOlderThreeMonths = false
      this.addComment = true
      this.addPhotoOrComment = false
      this.damagedStockAddCommentMsg = false
      this.sharedService.userNameset(null)
    } else if (reason === 'SHORT_OVER_SUPPLIED') {
      this.shortAndOverSuppliedReason = true
      this.reasonShortOnetime = true
      this.reasonChangeforShort = ' - Short supplied'

      // this.defaultHeaderWithReason = true;
      // this.defaultHeaderWithReason = true;
      this.shortAndOverSuppliedReason = true
      this.reasonView = false
      this.invoiceView = true
      this.isInstead = false
      this.shortAndOverSuppliedMsg = true
      this.damagedStockAddCommentBtn = false
      this.dateWithinThreeMonths = false
      this.dateOlderThreeMonths = false
      this.addComment = true
      this.addPhotoOrComment = false
      this.damagedStockAddCommentMsg = false
      this.sharedService.userNameset(null)
    } else if (reason === 'OVER_SUPPLIED') {
      this.defaultHeaderWithReason = true
      this.reasonFlag = true
      this.shortAndOverSuppliedReason = false
      this.reasonView = false
      this.invoiceView = true
      this.openModel(e, reason)
      this.damagedStockAddCommentBtn = false
      this.shortAndOverSuppliedMsg = false
      this.damagedStockAddCommentMsg = false
      this.dateWithinThreeMonths = false
      this.dateOlderThreeMonths = false
      this.shortAndOverSuppliedReason = false
      this.isStockObservable.next(true)
      this.addComment = true
      this.addPhotoOrComment = false
      this.sharedService.userNameset(null)
    } else if (reason === 'DAMAGED_STOCK') {
      this.defaultHeaderWithReason = true
      this.reasonView = false
      this.invoiceView = true
      this.damagedStockAddCommentBtn = true
      this.isStockObservable.next(false)
      this.isInstead = false
      this.shortAndOverSuppliedMsg = false
      this.dateWithinThreeMonths = false
      this.dateOlderThreeMonths = false
      this.otherDefaultReview = false
      this.dateOlderThreeMonths = false
      this.shortAndOverSuppliedReason = false
      this.addComment = false
      this.addPhotoOrComment = true
      this.damagedStockAddCommentMsg = true
      this.sharedService.userNameset(reason)
    } else if (reason === 'FAULTY_STOCK') {
      this.overSuppliedInstead = false
      this.defaultHeaderWithReason = true
      this.reasonView = false
      this.invoiceView = true
      this.damagedStockAddCommentBtn = true
      this.damagedStockAddCommentMsg = true
      this.shortAndOverSuppliedMsg = false
      this.isStockObservable.next(false)
      this.isInstead = false
      this.dateWithinThreeMonths = false
      this.dateOlderThreeMonths = false
      this.shortAndOverSuppliedReason = false
      this.addComment = false
      this.addPhotoOrComment = true
      this.sharedService.userNameset(reason)
    } else if (reason === 'REQUEST_RETURN') {
      this.invoiceView = true
      this.checkOlderDate(this.order.entries)
      if (this.requestReturnFlag == 'Y') {
        this.dateOlderThreeMonths = true
        this.notThreemonthOld = false
        this.invoiceView = true
        this.addPhotoOrComment = true
        this.addComment = false
      } else if (this.requestReturnFlag == 'N') {
        this.notThreemonthOld = true
        // this.reqReturnStockPanel = true;
        // this.dateWithinThreeMonths = true;

        this.dateOlderThreeMonths = false
        this.invoiceView = true
        //this.addPhotoOrComment = false;
      }
      this.addPhotoOrComment = true
      this.defaultHeaderWithReason = true
      this.reasonView = false
      this.isInstead = false
      this.shortAndOverSuppliedMsg = false
      // this.requestReturnStockReason = true;
      this.otherDefaultReview = false
      this.shortAndOverSuppliedReason = false
      this.damagedStockAddCommentMsg = false
      this.sharedService.userNameset(reason)
    } else if (reason === 'OTHER') {
      this.defaultHeaderWithReason = true
      this.reasonView = false
      this.addPhotoOrComment = true
      this.invoiceView = true
      this.dateOlderThreeMonths = false
      this.dateWithinThreeMonths = false
      this.isStockObservable.next(false)
      this.otherDefaultReview = true
      this.isInstead = false
      this.otherReasonReviewed = false
      this.damagedStockAddCommentMsg = false
      this.sharedService.userNameset(reason)
      // this.damagedStockAddCommentBtn = true;
    } else {
      this.invoiceView = false
      this.reasonView = false
      this.dateOlderThreeMonths = false
      this.defaultHeaderWithReason = false
      this.confirmationView = false
      this.damagedStockAddCommentMsg = false
    }
  }
  public damagedStockDefaultYes() {
    this.isPickupObservable.next(true)
    this.invoiceView = false
  }
  public otherReasonReview(e) {
    this.otherReasonReviewed = true
    this.invoiceView = false
    this.reqReturnStockPanel = false
    this.otherClaimReason = false
    this.shortAndOverSuppliedReason = false
    if (e.target.value == 'Yes') {
      this.otherReasonForm.addControl('otherReasonReviewCheck', new FormControl(false, Validators.requiredTrue))
      // this.claimForm.addControl("orderNumber", new FormControl('', Validators.required));
    }
    // if(e.target.value == "Yes"){
    //   this.otherReasonForm = new FormGroup({
    //     otherReasonReviewCheck: new FormControl(false, Validators.requiredTrue),
    //     // orderNumber: new FormControl('')
    //   });
    //   }

    // else{
    //   this.otherReasonForm = new FormGroup({
    //     otherReasonReviewCheck: new FormControl(false, Validators.requiredTrue),
    //   //  orderNumber: new FormControl('', Validators.required)
    //   });
    // }
  }
  public otherReasonisStockYes(e) {
    this.otherReasonIsStockReview = true
    this.isPickupObservable.next(false)
    if (e.target.value == 'Yes') {
      // this.otherReasonForm.addControl("otherreasonyes", new FormControl(false, Validators.requiredTrue));
      // this.claimForm.addControl("orderNumber", new FormControl('', Validators.required));
    }
  }
  public otherReasonisStockNo(e) {
    this.otherReasonIsStockReview = false
    this.isPickupObservable.next(true)
    this.isUpdatedCollection = false
    this.isPickUpDetails = false
    this.otherClaimReason = false
    // if(e.target.value == "No"){
    //   this.otherReasonForm.addControl("otherreasonno", new FormControl(false, Validators.requiredTrue));
    //   // this.claimForm.addControl("orderNumber", new FormControl('', Validators.required));
    // }
    if (e.target.value == 'No') {
      this.otherReasonForm = new FormGroup({
        otherreasonno: new FormControl(false, Validators.requiredTrue),
        otherReasonReviewCheck: new FormControl(false, Validators.requiredTrue)
      })
    }

    // else{
    //   this.otherReasonForm = new FormGroup({
    //     otherReasonReviewCheck: new FormControl(false, Validators.requiredTrue),
    //   //  orderNumber: new FormControl('', Validators.required)
    //   });
    // }
  }

  public onBackClicked(): void {
    this.reasonView = true
    this.invoiceView = false
    this.isReview = false
    this.confirmationView = false
    this.isPickUpDetails = false
    this.isOverSuppliedPdt.next(false)
    this.isInstead = true
    this.isPurchaseOrderNumber = false
    this.isUpdatedCollection = false
    this.isPickupObservable.next(false)
    this.overSuppliedInstead = false
    this.damagedStockAddCommentBtn = false
    this.damagedStockAddCommentMsg = false
    this.faultyStockMsg = false
    this.shortAndOverSuppliedMsg = false
    this.reStockFees = false
    this.dateWithinThreeMonths = false
    this.dateOlderThreeMonths = false
    this.returnStockReviewed = false
    this.reqReturnStockPanel = false
    this.otherDefaultReview = false
    this.otherReasonReviewed = false
    this.otherReasonIsStockReview = false
    this.shortAndOverSuppliedReason = false
    this.defaultHeaderWithReason = false
    this.addComment = false
    this.addPhotoOrComment = false

    // this.totalClaims(0);
    this.claimValue = ''
    this.claimForm.reset()

    // this.claimReasonForm.get('claimReasonControl').setValue(" ");
    // window.location.reload();
    this.reload()
  }

  reload() {
    // any other execution
    //this.ngOnInit();
  }

  public getOrder(orderCode: string): void {
    this.orderHistoryService.getOrderById(orderCode).subscribe(
      (order: Order) => {
        if (order) {
          this.order = order
          this.validateOrderEnteriesForClaim(order.entries)
          this.generateFormControl(order.entries)
          this.changeDetectorRef.detectChanges()
          this.checkOlderDate(order.entries)
        }
      },
      (err) => {
        this.globalMessageService.add(SharedValue.incorrectorderNumber, GlobalMessageType.MSG_TYPE_ERROR)
        // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
        this.routingService.go({ cxRoute: CustomRoutes.CREDIT_CLAIMS })
      }
    )
  }

  public validateOrderEnteriesForClaim(entries: ICustomOrderEntry[]) {
    entries.forEach((orderEntry) => {
      if (orderEntry?.orderEntryStatusDisplay === 'Delivered' || orderEntry?.orderEntryStatusDisplay === 'Completed') {
        this.newOrderEnteries.push(orderEntry)
      }
    })
    entries = []
    this.order.entries = []
    this.newOrderEnteries.forEach((entry) => entries.push(Object.assign({}, entry)))
    this.order.entries = entries
  }

  public onPhotoClicked(): void {
    // this.modalRef = this.modalService.openDialog(NewCreditClaimPhotoUploadModalComponent, { centered: true, size: 'lg' });
    // this.modalRef = this.modalService.openDialog('NewCreditClaimPhotoUploadModalComponent', { centered: true, size: 'lg' });
    this.openDialog()

    // this.modalRef = this.launchDialogService.openDialog(
    // 	LAUNCH_CALLER.ADDED_TO_CART,
    // 	undefined,
    // 	undefined,
    // 	NewCreditClaimPhotoUploadModalComponent
    // );

    // this.modalRef.componentInstance.claimComment = this.getCreditClaimComment();
    // this.modalRef.result
    //   .then((creditClaimPhotoAndComment) => {
    //     this.setCreditClaimComments(creditClaimPhotoAndComment?.comment);
    //     this.setCreditClaimMediaUpload(creditClaimPhotoAndComment?.creditClaimMediaUploads);
    //   })
    //   .catch(() => {
    //   });
  }

  //   protected openModal() {
  //    const dialogRef = this.launchDialogService.openDialog(
  //      LAUNCH_CALLER.CUSTOM_COMMENTS,
  //      this.openElement,
  //      this.vcr,
  //     //  NewCreditClaimPhotoUploadModalComponent
  //    );
  // //   this.dialogRef.submitClicked.subscribe(result => {
  // //     console.log('Got the data! ', result);
  // // });
  //   //  dialogRef?.pipe().subscribe();
  //    this.launchDialogService.dialogClose.subscribe(result => {
  //     console.log("result", result);
  //     this.addPopupComments = result.comment;
  //     this.addPopupImage = result.creditClaimMediaUploads;
  //    });
  //    dialogRef?.pipe(take(this.addPopupComments)).subscribe();
  //     // this.dialogRef.result
  //     //   .then((creditClaimPhotoAndComment) => {
  //     //     this.setCreditClaimComments(creditClaimPhotoAndComment?.comment);
  //     //     this.setCreditClaimMediaUpload(creditClaimPhotoAndComment?.creditClaimMediaUploads);
  //     //   })
  //     //   .catch(() => {
  //     //   });
  //   //  this.sharedService.dialogData(dialogRef);
  //  }

  changeclaim: any

  secondCliamModel() {
    this.invoiceView = true
    this.isOverSuppliedPdt.next(false)
    const dialogRef = this.dialog.open(SecondClaimModalComponent, {
      data: {
        changeClaim: this.changeclaim
      }
    })
    dialogRef.closed.subscribe((result: any) => {
      if (result.data == 'close') {
        this.isInstead = true
        this.shortAndOverSuppliedReason = false
        this.defaultHeaderWithReason = true
      } else {
        if (result.data == 'true') {
          setTimeout(() => {
            this.defaultHeaderWithReason = false
            this.shortAndOverSuppliedReason = true
            this.reasonChange = ' - Short Supplied '
            this.cd.detectChanges()
          }, 100)

          this.invoiceView = true
          //  this.reasonChange = " - Short Supplied"
          // this.shortAndOverSuppliedReason = true;
          // this.defaultHeaderWithReason = false;
        }
      }
    })
  }
  public openDialog(): void {
    const dialogRef = this.dialog.open(NewCreditClaimPhotoUploadModalComponent, {})
    dialogRef.closed.subscribe((result: any) => {
      // if (result.comment) {
      this.addPopupComments = result.comment
      // } else {
      // if (result.creditClaimMediaUploads.length) {
      setTimeout(() => {
        this.addPopupImage = result.creditClaimMediaUploads[0].code
        this.addPopupImageLength = result.creditClaimMediaUploads.length
        this.cd.detectChanges()
      }, 100)
      // }
      // }
    })
  }

  openModel(e, modalreason: string) {
    this.setCreditClaimItems(this.getClaimItems())
    const claimsReason = modalreason

    if ((this.creditClaim.items && this.creditClaim.items.length > 0) || claimsReason === 'OVER_SUPPLIED') {
      this.isReview = false
      let reasonName: string
      if (claimsReason == 'SHORT_OVER_SUPPLIED') {
        var modalText = 'Step 2 Complete the following to confirm the items you were over supplied.'
        // this.reasonChange = " - Over Supplied"
      } else if (claimsReason == 'SHORT_SUPPLIED') {
        modalText = 'Thanks for confirming. You are now creating a second claim.'
      } else if (claimsReason == 'OVER_SUPPLIED') {
        modalText = ''
      } else {
        modalText = ''
      }

      this.isPickupObservable.next(false)
      this.otherClaimReason = false
      const dialogRef = this.dialog.open(ShortOversuppliedModalComponent, {
        data: {
          changeClaims: this.changeclaims,
          modalText: modalText,
          isreason: reasonName
        }
      })
      if (claimsReason === 'OVER_SUPPLIED') {
        this.defaultHeaderWithReason = true
        this.shortAndOverSuppliedReason = false
      } else if (claimsReason === 'SHORT_SUPPLIED') {
        // this.shortAndOverSuppliedReason = true;
        // this.defaultHeaderWithReason = false;

        //  this.shortAndOverSuppliedReason = true;
        this.defaultHeaderWithReason = true
      }

      dialogRef.closed.subscribe((result: any) => {
        if (result.data == 'close') {
          setTimeout(() => {
            this.cd.detectChanges()
          }, 500)
          this.isInstead = true
          this.shortAndOverSuppliedReason = false
          this.defaultHeaderWithReason = true
        } else {
          if (result.data == 'false') {
            this.creditClaim.invoiceQuestion = 'No'
            const reasons = this.claimReasonForm.get('claimReasonControl').value
            if (reasons === 'SHORT_SUPPLIED' || reasons === 'SHORT_OVER_SUPPLIED') {
              this.reasonChange = ' - Over Supplied'
              this.shortAndOverSuppliedReason = true
              this.defaultHeaderWithReason = false
            } else if (reasons == 'OVER_SUPPLIED') {
              this.shortAndOverSuppliedReason = false
              this.defaultHeaderWithReason = true
            } else {
              this.reasonChange = ' - Short Supplied'
              this.shortAndOverSuppliedReason = false
              this.defaultHeaderWithReason = true
            }

            this.reasonShortOnetime = false
            // this.reasonChange = " - Over Supplied"
            //   this.reasonChange = " - Short Supplied"
            //  this.shortAndOverSuppliedReason = false;
            //  this.defaultHeaderWithReason = true;
            this.isStockObservable.next(true)
            this.isInstead = false
            this.isOverSuppliedPdt.next(true)
            this.shortAndOverSuppliedMsg = false
          } else {
            setTimeout(() => {
              this.invoiceView = true
              this.cd.detectChanges()
              this.isStockObservable.next(true)
            }, 100)
            this.isStockObservable.next(true)
            this.isOverSuppliedPdt.next(false)
            this.creditClaim.invoiceQuestion = 'Yes'
            this.isInstead = false
            this.shortAndOverSuppliedMsg = false
            //this.claimValue = 0;
            this.shortAndOverSuppliedReason = false
            //this.defaultHeaderWithReason = true;
            if (claimsReason == 'SHORT_OVER_SUPPLIED' || claimsReason == 'SHORT_SUPPLIED') {
              this.reasonShortOnetime = false
              this.reasonChange = ' - Over Supplied'
              this.shortAndOverSuppliedReason = true
              this.defaultHeaderWithReason = false
              this.isDisabled = true
            }
          }
        }
      })
    } else {
      this.globalMessageService.add(SharedValue.selectQuantity, GlobalMessageType.MSG_TYPE_ERROR)
      this.spinner = false
      e.target.checked = false
      this.isReview = false
    }
  }

  public onReasonEditClicked(): void {
    this.otherReasonReviewed = false
    this.dateWithinThreeMonths = false
    this.dateOlderThreeMonths = false
    this.isPickupObservable.next(false)
    this.reasonView = true
    this.invoiceView = false
    this.shortAndOverSuppliedReason = false
    this.requestReturnStockReason = false
    this.shortAndOverSuppliedReason = false
    this.defaultHeaderWithReason = false
    this.addComment = false
    this.addPhotoOrComment = false
    this.isReview = false
    this.isPurchaseOrderNumber = false
    this.overSuppliedInstead = false
    this.claimReasonForm.reset()
    this.claimForm.reset()
    this.claimValue = ''
    // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
    const dataArray = this.claimForm.get('matData') as FormArray
    dataArray.controls.forEach((valCode) => valCode.patchValue({ materialCode: '' }))
    dataArray.controls.forEach((valCode) => valCode.patchValue({ itemDesc: '' }))
    dataArray.controls.forEach((valCode) => valCode.patchValue({ materialQuantity: '' }))
    this.reload()
  }

  public generateFormControl(orderEntryArray: OrderEntry[]): void {
    orderEntryArray.forEach((orderEntry) => {
      const key = orderEntry?.product?.code
      const claimQuantityMax: number = orderEntry?.quantity
      this.claimForm.addControl(key, new FormControl('', Validators.max(claimQuantityMax)))
    })
  }

  public onNewClaimSubmit(): void {
    this.setClaimValues()
    if (this.creditClaim.items && this.creditClaim.items.length > 0) {
      // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
      const selectedReason = this.claimReasonForm.get('claimReasonControl').value

      const x = this.photoMandatoryReasons.includes(selectedReason)
      const y = this.commentMandatoryReasons.includes(selectedReason)
      this.creditClaim.comments[0].text = this.addPopupComments
      if (this.addPopupImageLength != undefined && this.addPopupImageLength > 0) {
        const media: ICustomMedia[] = []
        const mediaFile = {} as ICustomMedia
        mediaFile.code = this.addPopupImage
        media.push(mediaFile)
        this.creditClaim.images = media
      } else {
        this.creditClaim.images = []
      }
      if (
        this.photoMandatoryReasons.includes(selectedReason) &&
        (this.creditClaim.images == undefined ||
          this.creditClaim.images.length == 0 ||
          this.addPopupImageLength == 0 ||
          this.addPopupImageLength == undefined)
      ) {
        this.globalMessageService.add(SharedValue.photoMandatory, GlobalMessageType.MSG_TYPE_ERROR)
        this.spinner = false
        this.changeDetectorRef.detectChanges()
      } else if (
        selectedReason == 'DAMAGED_STOCK' &&
        selectedReason == 'FAULTY_STOCK' &&
        selectedReason == 'REQUEST_RETURN' &&
        selectedReason == 'OTHER'
      ) {
        // if (this.creditClaim.comments[0].text == null || this.creditClaim.comments[0].text.toLowerCase() == "") {
        if (this.addPopupComments == null || this.addPopupComments.toLowerCase() == '') {
          this.globalMessageService.add(SharedValue.commentMandatory, GlobalMessageType.MSG_TYPE_ERROR)
          this.spinner = false
          this.changeDetectorRef.detectChanges()
        }
      } else {
        if (this.shortAndOverSuppliedReason !== true) {
          this.creditClaim
        } else {
          //this.creditClaim.reason = "SHORT_OVER_SUPPLIED"
          this.creditClaim.reason = this.shortOversupplied
        }
        this.creditClaimsService
          .submitCreditClaim(this.creditClaim)
          .pipe(
            finalize(() => {
              this.spinner = false
              this.changeDetectorRef.detectChanges()
            })
          )
          .subscribe(
            (response) => {
              this.globalMessageService.add(SharedValue.creditClaimSubmitted, GlobalMessageType.MSG_TYPE_CONFIRMATION)
              this.submittedReason = response.reason
              this.submittedTicket = response.ticketId
              this.submittedRelatedTicketId = response.relatedTicketId
              if (response.ticketId && response.relatedTicketId) {
                this.ShortOverSuppliedRelatedTicketId = true
              } else if (response.ticketId) {
                this.onlyTicketId = true
              } else if (response.relatedTicketId) {
                this.onlyRelatedTicketId = true
              } else {
                this.onlyTicketId = false
              }

              this.showConfirmationView()
            },
            (err) => {
              this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
            }
          )
      }
    } else {
      this.globalMessageService.add(SharedValue.selectQuantity, GlobalMessageType.MSG_TYPE_ERROR)
      this.spinner = false
      this.changeDetectorRef.detectChanges()
    }
  }

  public moveToNextInput(i): void {
    const inputs = this.textInputs.toArray()
    const nextInput = inputs[i + 1]
    if (nextInput) {
      nextInput.nativeElement.focus()
    }
  }

  public setClaimValues(): void {
    this.spinner = true
    this.changeDetectorRef.detectChanges()
    this.setClaimReason()
    this.setInvoiceNumber()
    this.setUser()
    this.setClaimDate()
    this.setCreditClaimItems(this.getClaimItems())
    this.setCreditClaimComments(this.getCreditClaimComment())
    this.setPurchaseOrderNumber()
    this.setAddressOrComments()
    this.setAmount()
  }

  public showConfirmationView(): void {
    this.reasonView = false
    this.invoiceView = false
    this.confirmationView = true
    this.addComment = false
    this.addPhotoOrComment = false
    this.defaultHeaderWithReason = false
    this.shortAndOverSuppliedReason = false
    this.isPickupObservable.next(false)
    this.confirmView = false
    this.otherReasonReviewed = false
    this.dateWithinThreeMonths = false
    this.reStockFees = false
    this.returnStockReviewed = false
    this.reqReturnStockPanel = false
  }

  public setClaimReason(): void {
    this.creditClaim.reason = this.claimReasonForm.value.claimReasonControl
  }
  public setPurchaseOrderNumber(): void {
    this.creditClaim.purchaseOrderNumber = this.claimForm.value.orderNumber ? this.claimForm.value.orderNumber : ''
  }
  public setAddressOrComments(): void {
    this.creditClaim.description = this.pickupForm.value.addressTextArea ? this.pickupForm.value.addressTextArea : ''
  }
  public setInvoiceNumber(): void {
    this.creditClaim.invoiceNumber = this.orderCode ? this.orderCode : null
  }

  public setUser(): void {
    this.user$.subscribe((user) => {
      if (user) {
        this.creditClaim.createdBy = user.uid
      }
    })
  }

  public setClaimDate(): void {
    const today = new Date()
    this.creditClaim.claimDate = this.datepipe.transform(today, "yyyy-MM-dd'T'HH:mm:ssZ")
  }

  public getClaimItems(): CreditClaimItem[] {
    // this.getOrder(this.orderCode);
    //  this.orderHistoryService.getOrderById(this.orderCode).subscribe((order: Order) => {
    //   if (order) {
    //     this.order = order;
    //     this.generateFormControl(order.entries);

    //   }
    let claimFormValues
    this.claimForm.updateValueAndValidity()
    let claimFormdata = this.claimForm.getRawValue()
    let materialData = []
    const resultData = []
    const matObj = {}
    //  materialData = claimFormdata.materialData;
    materialData = claimFormdata.matData
    if (materialData) {
      for (let i = 0; i < materialData.length; i++) {
        let key = ''
        let val = 0
        // key = materialData[i].materialCode.code;
        key = materialData[i].materialCode.code
        val = materialData[i].materialQuantity

        matObj[key] = val

        //claimFormdata = matObj;

        resultData.push(matObj)
        //  let key = item.code;
        this.claimForm.addControl(key, new FormControl(val))
      }
    }
    // if(this.materialQtyFlag == false) {
    //   this.globalMessageService.add(SharedValue.selectQuantity, GlobalMessageType.MSG_TYPE_ERROR);
    //   this.spinner = false;
    // }
    claimFormdata = null
    claimFormdata = this.claimForm.getRawValue()

    claimFormValues = Object.assign({}, claimFormdata, matObj)

    const creditClaimItems: CreditClaimItem[] = []

    if (claimFormValues) {
      const filteredkey = Object.keys(claimFormValues).filter((key) => {
        return key !== 'accept' && key !== 'orderNumber' && key !== 'materialData'
      })

      filteredkey.forEach((orderCode) => {
        const cailmQuantity = claimFormValues[orderCode]
        // const cailmQuantity = this.claimForm.get(orderCode).value;
        if (cailmQuantity && cailmQuantity > 0) {
          let findresult = null
          findresult = this.customEntries.find((item) => item.product?.code === orderCode)
          const creditClaimItem: CreditClaimItem = new CreditClaimItem()
          if (findresult) {
            const deliveredQuantity = findresult.deliveredQuantity
            const basePrice = findresult.basePrice
            creditClaimItem.claimQuantity = cailmQuantity
            creditClaimItem.productCode = orderCode
            creditClaimItem.deliveredQuantity = deliveredQuantity
            creditClaimItem.itemPrice = basePrice?.value
            this.productUom = findresult.product.unit.code
            creditClaimItem.uom = findresult.product.unit.code
            // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
            const getReason = this.claimReasonForm.get('claimReasonControl').value
            // new

            if (this.newArrays.includes(findresult.product.code)) {
              creditClaimItem.overSuppliedItem = true
              creditClaimItem.uom = findresult.product.unit.code
            } else {
              creditClaimItem.overSuppliedItem = false
              creditClaimItem.uom = findresult.product.unit.code
            }
            this.customEntries.forEach((element) => {
              if (element.product?.code == orderCode && getReason == 'OVER_SUPPLIED') {
                if (this.shortSuppliedInsteadForm) {
                  creditClaimItem.overSuppliedItem = false
                } else {
                  creditClaimItem.overSuppliedItem = true
                }
              }
            })
          } else {
            creditClaimItem.claimQuantity = cailmQuantity
            creditClaimItem.productCode = orderCode
            creditClaimItem.deliveredQuantity = 0
            creditClaimItem.itemPrice = 0
            creditClaimItem.overSuppliedItem = true
            //creditClaimItem.uom = this.productUom;
            this.searchUom.forEach((element) => {
              if (element.code == orderCode) {
                creditClaimItem.uom = element.unit.code
              }
            })
            //creditClaimItem.overSuppliedItem = false;
          }

          creditClaimItems.push(creditClaimItem)
        }
      })
    }
    return creditClaimItems
  }

  // public addTableItem(claimFormValues) {
  //   if (claimFormValues) {
  //     const filteredkey = Object.keys(claimFormValues).filter(key =>{ return key !== "accept" && key !== "orderNumber"});

  //       filteredkey.forEach(orderCode => {

  //         const cailmQuantity = this.claimForm.get(orderCode).value;
  //         if (cailmQuantity && cailmQuantity > 0) {

  //           const { deliveredQuantity, basePrice } = this.customEntries.find((item) => item.product?.code === orderCode);
  //           const creditClaimItem: CreditClaimItem = new CreditClaimItem();
  //           creditClaimItem.claimQuantity = cailmQuantity;
  //           creditClaimItem.productCode = orderCode;
  //           creditClaimItem.deliveredQuantity = deliveredQuantity;
  //           creditClaimItem.itemPrice = basePrice?.value;
  //           creditClaimItem.overSuppliedItem = false;
  //           creditClaimItems.push(creditClaimItem);
  //         }
  //       });

  //   }
  // }
  public checkOlderDate(date) {
    const threeMonthsAgo = new Date()
    const orderDeliveryDate = date[0].deliveredDate
    //const orderDeliveryDate = "2022-03-03T14:00:00+0000";
    const checkDeliveredDate = new Date(orderDeliveryDate)
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3)
    if (+threeMonthsAgo > +checkDeliveredDate) {
      this.requestReturnFlag = 'Y'
    } else if (+threeMonthsAgo <= +checkDeliveredDate) {
      this.requestReturnFlag = 'N'
    } else {
      this.requestReturnFlag = ''
    }
  }

  public setCreditClaimItems(creditClaimItem: CreditClaimItem[]) {
    this.creditClaim.items = creditClaimItem
  }

  public getCreditClaimComment(): string {
    if (this.creditClaim?.comments) {
      return this.creditClaim?.comments[0]?.text
    } else return null
  }

  public setCreditClaimComments(comment: string) {
    this.creditClaim.comments = []
    this.creditClaim.comments[0] = new CMSCommentWsDTOCMSCommentWsDTO()
    this.creditClaim.comments[0].text = comment
  }

  public setCreditClaimMediaUpload(creditClaimMediaUploads: CreditClaimMediaUpload[]): void {
    const media: ICustomMedia[] = []
    if (creditClaimMediaUploads) {
      creditClaimMediaUploads.forEach((creditClaimMediaUpload) => {
        const mediaFile = {} as ICustomMedia
        mediaFile.code = creditClaimMediaUpload.code
        media.push(mediaFile)
      })
    }
    this.creditClaim.images = media
  }
  public get customEntries(): ICustomOrderEntry[] {
    return this.order?.entries
  }

  totalClaim: any = []
  totalPrice(e) {
    this.totalClaim.push(e)
  }

  @ViewChildren('numberData') inputs: QueryList<any>

  totalClaims(e, orderEntry) {
    if (e.target.value > orderEntry.quantity) {
      this.isDisabled = true
    } else {
      this.isDisabled = false
    }

    setTimeout(() => {
      // TODO:Spartacus - Method 'get' was removed from Class 'UserService'. Use 'UserAccountFacade.get()' from '@spartacus/user' instead.
      const getReasonnew = this.claimReasonForm.get('claimReasonControl').value
      if (getReasonnew == 'OVER_SUPPLIED' && this.shortAndOverSuppliedReason == false) {
        this.newArrays.push(orderEntry.product.code)
      } else if (this.shortAndOverSuppliedReason == true && this.reasonFlag == true) {
        //this.newArrays.push(orderEntry.product.code)
      } else if (getReasonnew == 'SHORT_SUPPLIED' && this.shortAndOverSuppliedReason == false) {
        //this.newArrays.push(orderEntry.product.code)
      } else if (this.shortAndOverSuppliedReason == true && this.reasonShortOnetime == true) {
        //this.newArrays.push(orderEntry.product.code)
      } else if (this.shortAndOverSuppliedReason == true && this.reasonFlag == false) {
        this.newArrays.push(orderEntry.product.code)
      }
      // else if(this.reasonFlag == true){
      //   this.newArrays.push(orderEntry.product.code)
      // }

      this.cd.detectChanges()
    }, 0)

    // end..

    if (e == 0) {
      this.claimValue = ''
    } else {
      this.GstValue = this.inputs.toArray().map((input) => input.nativeElement.value)
      this.claimValue = this.GstValue.reduce((accumulator, currentValue) => {
        if (accumulator == '') {
          accumulator = '0'
        }
        if (currentValue == '') {
          currentValue = '0'
        }
        if (this.reasonShortOnetime == true) {
          // if(i ==  "0" || i == "1"){
          accumulator = accumulator
          currentValue = currentValue
          if (accumulator == '0' || currentValue == '0') {
            this.firstValues = accumulator
            this.secondValues = currentValue
          }
          // }
        }
        if (this.reasonShortOnetime == false) {
          if (this.firstValues == '0') {
            accumulator = this.firstValues
          }
          if (this.secondValues == '0') {
            currentValue = this.secondValues
          }
        }

        const finalTotals = parseFloat(accumulator) + parseFloat(currentValue)
        return finalTotals.toFixed(2)
        // return parseInt(accumulator) + parseInt(currentValue);
      })
    }
  }

  setAmount() {
    this.creditClaim.amount = this.claimValue
  }

  notRequired = false

  reviewedClaimNo(e) {
    this.isReview = e.target.checked
    this.claimGstValue = !this.claimGstValue
    this.notRequired = true
    if (e.target.value == 'Yes') {
      this.claimForm.addControl('accept', new FormControl(false, Validators.requiredTrue))
      this.claimForm.addControl('orderNumber', new FormControl('', Validators.required))
    } else if (e.target.value == 'No') {
      this.claimForm.addControl('accept', new FormControl(false, Validators.requiredTrue))
    }
    this.spinner = false
    //  if(e.target.value == "Yes"){
    // this.claimForm = new FormGroup({
    //   accept: new FormControl(false, Validators.requiredTrue),
    //   orderNumber: new FormControl('')
    // });
    // }
    // else{
    //   this.claimForm = new FormGroup({
    //     accept: new FormControl(false, Validators.requiredTrue),
    //    orderNumber: new FormControl('', Validators.required)
    //   });

    // }
  }

  reviewedBtnChecked(e) {
    this.reqReturnStockPanel = e.target.checked
    if (e.target.checked == true) {
      this.dateWithinThreeMonths = true
      this.reStockFees = true
      this.invoiceView = false
    }
    // this.dateWithinThreeMonths = true;
    // this.invoiceView  = false;
  }

  pickUpadd(e) {
    if (e.target.value == 'Yes') {
      this.claimForm.addControl('accept', new FormControl(false, Validators.requiredTrue))
      this.claimForm.addControl('orderNumber', new FormControl('', Validators.required))
    }
    // if(e.target.value == "Yes"){
    //   this.claimForm = new FormGroup({
    //     accept: new FormControl(false, Validators.requiredTrue),
    //     orderNumber: new FormControl('')
    //   });
    //   }
    //   else{
    //     this.claimForm = new FormGroup({
    //       accept: new FormControl(false, Validators.requiredTrue),
    //     //  orderNumber: new FormControl('', Validators.required)
    //     });
    //   }
  }

  purchaseOrderNumber(e, claimreason) {
    this.isPurchaseOrderNumber = !this.isPurchaseOrderNumber
    this.creditClaim.stockQuestion = 'Yes'
    if (claimreason == 'SHORT_SUPPLIED') {
      this.isReview = true
      this.overSuppliedInstead = false
    } else if (claimreason == 'SHORT_OVER_SUPPLIED') {
      this.isReview = true
      this.overSuppliedInstead = false
    } else if (claimreason == 'OVER_SUPPLIED') {
      this.overSuppliedInstead = true
      this.invoiceView = true
      this.isReview = false
    } else {
      this.invoiceView = true
    }

    const key8 = 'accept'
    this.claimForm.addControl(key8, new FormControl(false, Validators.requiredTrue))
    const key9 = 'orderNumber'
    this.claimForm.addControl(key9, new FormControl('', Validators.required))
    this.spinner = false
    // if(e.target.value == "Yes"){
    //   this.claimForm.addControl("accept", new FormControl(false, Validators.requiredTrue));
    //     this.claimForm.addControl("orderNumber", new FormControl('', Validators.required));
    //   }

    // if(e.target.value == "Yes"){
    // this.claimForm = new FormGroup({
    //   accept: new FormControl(false, Validators.requiredTrue),
    //   orderNumber: new FormControl('', Validators.required)
    // });

    // }
    // else{
    //   this.claimForm = new FormGroup({
    //     accept: new FormControl(false, Validators.requiredTrue),
    //     orderNumber: new FormControl('', Validators.required)
    //   });
    // }
  }

  public returnStockYes(e) {
    this.selectedYesstock = e.target.value
    this.reStockFees = true
    this.isPickupObservable.next(false)
    this.invoiceView = false
    this.isPurchaseOrderNumber = false
    if (e.target.value == 'Yes') {
      this.stockForm.addControl('returnstockyes', new FormControl(false, Validators.requiredTrue))
      // this.claimForm.addControl("orderNumber", new FormControl('', Validators.required));
    }
    this.spinner = false
  }

  public returnStockNo(e) {
    this.selectedNostock = e.target.value
    // this.isPickupObservable.next(true);
    this.requestReturnStockReason = false
    // this.reStockFees = false;
    this.reStockFees = true
    if (e.target.value == 'No') {
      this.stockForm.addControl('returnstockno', new FormControl(false, Validators.requiredTrue))
      // this.claimForm.addControl("orderNumber", new FormControl('', Validators.required));
    }
    this.spinner = false
  }

  public restockFeesYes(e) {
    //this.returnStockReviewed = true;

    this.isPickupObservable.next(true)
    this.dateWithinThreeMonths = true

    if (this.selectedNostock == 'No' && e.target.value == 'Yes') {
      // this.isPickupObservable.next(true);
      this.dateWithinThreeMonths = true
      this.returnStockReviewed = false
      this.reStockFees = true
    } else if (this.selectedYesstock == 'Yes' && e.target.value == 'Yes') {
      this.returnStockReviewed = true
      // this.isPickupObservable.next(false);
    } else {
      // this.isPickupObservable.next(false);
      // this.returnStockReviewed = false;
    }

    // if(e.target.value == "Yes"){
    //   this.stockForm.addControl("stockaccept", new FormControl(false, Validators.requiredTrue));
    //   // this.claimForm.addControl("orderNumber", new FormControl('', Validators.required));
    // }
    if (e.target.value == 'Yes') {
      this.stockForm = new FormGroup({
        stockaccept: new FormControl(false, Validators.requiredTrue)
        // orderNumber: new FormControl('')
      })
    } else {
      this.stockForm = new FormGroup({
        stockaccept: new FormControl(false, Validators.requiredTrue)
        // orderNumber: new FormControl('', Validators.required)
      })
    }
    this.spinner = false
  }

  public restockFeesNo(e): void {
    // this.modalRef = this.modalService.open(RestockFeesNoModalComponent, { centered: true, size: 'lg' });
    this.isPickupObservable.next(false)
    const dialogRef = this.dialog.open(RestockFeesNoModalComponent, {
      disableClose: true,
      height: '60%',
      width: '40%'
    })
    this.returnStockReviewed = false
    dialogRef.closed.subscribe((result: any) => {
      // this.returnStockReviewed = false;
      // this.dateWithinThreeMonths = true;
      // this.isPickupObservable.next(false);
      this.reStockFees = true
      if (result.data == 'close') {
        // this.isInstead = true;
        // this.isStockObservable.next(false);
      } else {
        if (result.data == 'false') {
          setTimeout(() => {
            this.cd.detectChanges()
          }, 500)
          // this.isStockObservable.next(true);

          // this.isInstead = false;
          // this.isOverSuppliedPdt.next(true);
          // this.shortAndOverSuppliedMsg = false;
        } else {
          // this.isStockObservable.next(true);
          // this.isOverSuppliedPdt.next(false);
          // this.isInstead = false;
          // this.shortAndOverSuppliedMsg = false;
        }
      }
      this.reStockFees = false
      /*this.changeclaims = result.data;

       if (this.changeclaims==true) {
         this.isStock = true
         this.isInstead = false

       }
       else {
         this.isStock = false
         this.isInstead = true
       }
 */
    })
    this.spinner = false
    // this.modalRef.componentInstance.claimComment = this.getCreditClaimComment();
    // this.modalRef.result
    //   .then((creditClaimPhotoAndComment) => {
    //     this.setCreditClaimComments(creditClaimPhotoAndComment?.comment);
    //     this.setCreditClaimMediaUpload(creditClaimPhotoAndComment?.creditClaimMediaUploads);
    //   })
    //   .catch(() => {
    //   });
  }

  public onOverSuppliedInsteadYes(e) {
    this.isReview = true
    this.isStockObservable.next(false)
    this.overSuppliedInstead = false
    this.isPurchaseOrderNumber = false
    this.shortSuppliedInsteadForm = true
    // this.defaultHeaderWithReason = false;
    // this.shortAndOverSuppliedReason = true;
    // this.reasonChange = " - Short Supplied "
    if (e.target.value == 'Yes') {
      this.claimForm.addControl('accept', new FormControl(false, Validators.requiredTrue))

      setTimeout(() => {
        this.isStockObservable.next(false)
        this.cd.detectChanges()
        // this.totalClaims(e);
      }, 500)

      // this.claimForm.addControl("orderNumber", new FormControl('', Validators.required));
    }

    // else {
    //   this.claimForm.addControl("accept", new FormControl(false, Validators.requiredTrue));
    //   this.claimForm.addControl("orderNumber", new FormControl('', Validators.required));
    // }

    // if(e.target.value == "Yes"){
    // this.claimForm = new FormGroup({
    //   accept: new FormControl(false, Validators.requiredTrue),
    //   orderNumber: new FormControl('')
    // });
    // }
    // else{
    //   this.claimForm = new FormGroup({
    //     accept: new FormControl(false, Validators.requiredTrue),
    //     orderNumber: new FormControl('', Validators.required)
    //   });
    // }
  }
  onOverSuppliedInsteadNo(e) {
    this.isReview = true
    this.isStockObservable.next(true)
    this.overSuppliedInstead = true
    this.invoiceView = true
    this.isPurchaseOrderNumber = true
    this.shortSuppliedInsteadForm = false

    if (e.target.value == 'No') {
      this.claimForm.addControl('accept', new FormControl(false, Validators.requiredTrue))
      this.claimForm.addControl('orderNumber', new FormControl('', Validators.required))
    }
    // if(e.target.value == "Yes"){
    // this.claimForm = new FormGroup({
    //   accept: new FormControl(false, Validators.requiredTrue),
    //   orderNumber: new FormControl('')
    // });
    // }
    // else{
    //   this.claimForm = new FormGroup({
    //     accept: new FormControl(false, Validators.requiredTrue),
    //     orderNumber: new FormControl('', Validators.required)
    //   });
    // }
  }
  pickUpDetails(e, reasons) {
    this.isPickUpDetails = !this.isPickUpDetails
    this.isUpdatedCollection = false
    this.creditClaim.addressQuestion = 'Yes'

    // if(e.target.value == "Yes") {
    //   this.pickupForm.addControl("pickupaccept", new FormControl(false, Validators.requiredTrue));
    //   }
    // else {
    //     this.pickupForm.addControl("addressTextArea", new FormControl('', Validators.required));
    //     this.pickupForm.addControl("updateaccept", new FormControl(false, Validators.requiredTrue));
    //   }
    // this.pickupForm.reset();
    // this.pickupForm.reset();
    if (e.target.value == 'Yes') {
      this.pickupForm = new FormGroup({
        pickupaccept: new FormControl(false, Validators.requiredTrue)
      })
    } else {
      this.pickupForm = new FormGroup({
        pickupaccept: new FormControl(false, Validators.requiredTrue),
        textArea: new FormControl('', Validators.required)
      })
    }
  }
  updateCollection(e) {
    this.isUpdatedCollection = !this.isUpdatedCollection
    this.isPickUpDetails = false
    this.creditClaim.addressQuestion = 'No'
    // if(e.target.value == "No") {
    //   this.pickupForm.addControl("addressTextArea", new FormControl('', Validators.required));
    //   this.pickupForm.addControl("updateaccept", new FormControl(false, Validators.requiredTrue));
    // }
    //else {
    //   this.pickupForm.addControl("pickupaccept", new FormControl(false, Validators.requiredTrue));
    // }
    // this.pickupForm.reset();
    // this.pickupForm.addControl('new', this.fb.control('', Validators.required));
    // this.pickupForm.pickupaccept.reset();
    // this.pickupaccept.reset()

    if (e.target.value == 'No') {
      this.pickupForm = new FormGroup({
        updateaccept: new FormControl(false, Validators.requiredTrue),
        addressTextArea: new FormControl('', Validators.required)
      })
    }
  }
  shortReasonChange() {
    this.invoiceView = false
    this.isStockObservable.next(true)
  }
  purchaseOrderNumberNo(e, modalreason: any) {
    this.creditClaim.stockQuestion = 'No'
    this.setCreditClaimItems(this.getClaimItems())
    if (this.creditClaim.items && this.creditClaim.items.length > 0) {
      const dialogRef = this.dialog.open(ShortOversuppliedModalCollectedComponent, {
        data: this.changeclaims2,
        disableClose: true
      })
      this.isPurchaseOrderNumber = false
      this.overSuppliedInstead = false
      this.isReview = false

      if (modalreason === 'OVER_SUPPLIED') {
        this.defaultHeaderWithReason = true
        this.shortAndOverSuppliedReason = false
      } else if (modalreason === 'SHORT_SUPPLIED') {
        // this.shortAndOverSuppliedReason = true;
        // this.defaultHeaderWithReason = false;

        this.shortAndOverSuppliedReason = true
        this.defaultHeaderWithReason = false
      }
      if (modalreason == 'OVER_SUPPLIED') {
        // let dialogRef = this.dialog.open(ShortOversuppliedModalCollectedComponent, { data: this.changeclaims2, disableClose: true   })

        dialogRef.closed.subscribe((result: any) => {
          const wouldYouLikeNoCheck: any = document.getElementById('defaultCheck5')
          wouldYouLikeNoCheck.checked = false
          this.changeclaims2 = result.data
          if (result.data == true) {
            //this.shortAndOverSuppliedReason = true;

            //this.shortAndOverSuppliedReason = true;
            //  this.defaultHeaderWithReason = true;

            this.requestReturnStockReason = false
            this.otherClaimReason = false
            // this.defaultHeaderWithReason = false;
            this.invoiceView = false
            this.isPickupObservable.next(true)
          } else {
            this.invoiceView = true
            this.isPickupObservable.next(false)
          }
          this.addComment = true
          this.addPhotoOrComment = false
        })
      } else {
        this.invoiceView = false
        this.isPickupObservable.next(true)
      }
    } else {
      this.globalMessageService.add(SharedValue.selectQuantity, GlobalMessageType.MSG_TYPE_ERROR)
      this.spinner = false
      e.target.checked = false
      this.isPickupObservable.next(false)
      this.isPurchaseOrderNumber = false
      this.isReview = false
    }
  }
  public validateQuantity(value: string, maxValue: string): void {
    if (this.shortOversupplied === 'SHORT_OVER_SUPPLIED') {
      if (+value > +maxValue) {
        this.globalMessageService.add({ key: 'shared.error.quantityMoreThanOrdered' }, GlobalMessageType.MSG_TYPE_ERROR)
      }
    } else if (+value > +maxValue) {
      this.globalMessageService.add({ key: 'shared.error.quantityMoreThanDelivery' }, GlobalMessageType.MSG_TYPE_ERROR)
    }
  }

  myplaceHolder = 'Search'
  checkPlaceHolder() {
    if (this.myplaceHolder) {
      this.myplaceHolder = null
      return
    } else {
      this.myplaceHolder = 'Search'
      return
    }
  }
}
